import AWS from "aws-sdk";

/**
 * Builds a Kinesis client on unauthenticated Cognito credentials.
 *
 * Config is per-client, not via AWS.config.update, so clients for different regions
 * can't clobber a shared global region.
 *
 * maxRetries: 0 — no SDK transport retry. The buffered flush in MobileAnalyticsHelper
 * does its own one-shot, explicit-error-only re-queue (matching Pinpoint's
 * resendLimit: 1, which was an app-level re-queue on 429/500, not a transport retry).
 * An SDK retry would additionally re-send on timeouts/network errors — the ambiguous
 * "did it land?" case Pinpoint deliberately dropped — and since Kinesis has no
 * de-duplication, that would create duplicate Redshift rows. No httpOptions.timeout
 * either: the flush is one request per tick, not a per-event write to time-bound.
 *
 * The region arg to CognitoIdentityCredentials is REQUIRED: its internal
 * cognito-identity client does not inherit region from AWS.Kinesis, and without it
 * credential resolution falls back to the unset AWS.config.region and fails with
 * "Missing region in config" on every write.
 */
export const getKinesisClient = (awsRegion, identityPoolId) => {
    const credentials = new AWS.CognitoIdentityCredentials(
        { IdentityPoolId: identityPoolId },
        { region: awsRegion }
    );

    return new AWS.Kinesis({
        region: awsRegion,
        credentials: credentials,
        maxRetries: 0
    });
};
